import {ValueObject} from '@s-ui/domain'

export class MarketedVersionValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {String} params.price
   * @param {String} params.url
   * @param {String} params.initDate
   * @param {String} params.endDate
   * */
}
